import React, { useState, useEffect } from "react";
import { CalculatorState } from "../../calculator.utility";
import styled from "styled-components";
import { getPaceTable, Pace, paceEquivalents } from "../../pace-fns/pace-fns";
import { PaceTableRow } from "./PaceTableRow";
import * as analytics from "../../analytics";
import { createDistanceLogData } from "../../analytics.utils";
import { List } from "../../generic-components/List";
type Props = {
  metrics: CalculatorState;
  onPaceChange?: (pace: Pace) => void;
};

const Container = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 13px;
  padding-top: 35px;
`;

const Table = styled.div`
  display: flex;
  flex-direction: column;
  width: 98%;
`;

export const PaceTable = React.memo(({ metrics, onPaceChange }: Props) => {
  const [paceData, setPaceData] = useState<Pace[]>([]);
  const [isRecalculating, setIsRecalculating] = useState(false);
  const updateTimeHandler = (pace: Pace) => {
    setIsRecalculating(true);
    onPaceChange && onPaceChange(pace);
  };
  const distanceDetailHandler = (index: number) => {
    const upperIndex =
      index === paceData.length - 1 ? paceData.length - 1 : index + 1;
    const lowerIndex = index === 0 ? 0 : index - 1;
    const lowerDistance =
      index === 0 ? undefined : paceData[lowerIndex].distance;
    const newPaceData = getPaceTable(
      metrics.pace,
      paceData[upperIndex].distance,
      lowerDistance
    );
    analytics.logEvent("Analysis", "Decompose Distance", {
      lowerBound: lowerDistance
        ? createDistanceLogData(lowerDistance)
        : "Lowest bound",
      upperBound: createDistanceLogData(paceData[upperIndex].distance),
    });
    setPaceData([
      ...paceData.slice(0, lowerIndex),
      ...newPaceData,
      ...paceData.slice(upperIndex + 1, paceData.length),
    ]);
  };

  useEffect(() => {
    isRecalculating
      ? setPaceData(
          paceEquivalents(
            metrics.pace,
            paceData.map((pace) => pace?.distance)
          )
        )
      : setPaceData(getPaceTable(metrics.pace, metrics.distance));
    setIsRecalculating(false);
  }, [metrics]);

  const renderPaceEntry = ({ index, style }: { index: number, style:string }) => (
    <PaceTableRow
      rowIndex={index}
      key={index}
      pace={paceData[index]}
      updateTimeHandler={updateTimeHandler}
      distanceDetailHandler={() => distanceDetailHandler(index)}
      style={style}
    />
  );

  return (
    <Container>
      <List
        rowHeight={70}
        rowCount={paceData.length}
        rowRenderer={renderPaceEntry}
      />
    </Container>
  );
});
